import { For, createMemo, createSignal } from "solid-js"
import {
  KB_CATEGORIES,
  KB_CATEGORY_BY_CODE,
  KB_DOMAINS,
  KNOWLEDGE_LIBRARY_URL,
  type KnowledgeCategoryCode,
} from "./knowledge-base-data"
import { KnowledgeGlyph } from "./knowledge-base-icons"

type KnowledgeFilter = KnowledgeCategoryCode | "all"

export function KnowledgeBaseView() {
  const [active, setActive] = createSignal<KnowledgeFilter>("all")
  const domains = createMemo(() =>
    active() === "all" ? KB_DOMAINS : KB_DOMAINS.filter((item) => item.category === active()),
  )

  return (
    <div class="kb-root">
      <div class="kb-container">
        {/* ── Hero：品牌 + 标题 + 入口按钮 ── */}
        <header class="kb-hero">
          <div class="kb-hero__brand">
            <img src="/zd-brand-logo.png" alt="智盾 · SSAI" class="kb-hero__logo" />
            <span class="kb-hero__divider" aria-hidden="true" />
            <h1 class="kb-hero__title">泛安全领域知识空间</h1>
          </div>

          <p class="kb-hero__sub">
            沉淀人工智能安全、内容治理与攻防对抗的核心资料，让每一次检索都有据可依。
          </p>

          <a class="kb-cta" href={KNOWLEDGE_LIBRARY_URL} target="_blank" rel="noopener noreferrer">
            <span>进入记忆资料库</span>
            <svg
              class="kb-cta__arrow"
              viewBox="0 0 16 16"
              fill="none"
              stroke="currentColor"
              stroke-width="1.7"
              stroke-linecap="round"
              stroke-linejoin="round"
              aria-hidden="true"
            >
              <path d="M3 8h9M8.6 4.4 12.2 8l-3.6 3.6" />
            </svg>
          </a>
        </header>

        {/* ── 分类筛选 ── */}
        <div class="kb-filters">
          <div class="kb-chips">
            <button
              type="button"
              class="kb-chip"
              classList={{ "kb-chip--active": active() === "all" }}
              onClick={() => setActive("all")}
            >
              全部
            </button>
            <For each={KB_CATEGORIES}>
              {(category) => (
                <button
                  type="button"
                  class="kb-chip"
                  classList={{ "kb-chip--active": active() === category.code }}
                  onClick={() => setActive(category.code)}
                >
                  {category.label}
                </button>
              )}
            </For>
          </div>
          <span class="kb-filters__count">{domains().length} 个主题</span>
        </div>

        {/* ── 领域卡片 ── */}
        <div class="kb-grid">
          <For each={domains()}>
            {(domain) => {
              const category = KB_CATEGORY_BY_CODE[domain.category]
              return (
                <a
                  class="kb-card"
                  href={KNOWLEDGE_LIBRARY_URL}
                  target="_blank"
                  rel="noopener noreferrer"
                  data-kb-category={domain.category}
                >
                  <div class="kb-card__cover">
                    <KnowledgeGlyph name={category.glyph} class="kb-card__glyph" />
                    <span class="kb-card__badge">{category.label}</span>
                  </div>

                  <div class="kb-card__body">
                    <h3 class="kb-card__title">{domain.title}</h3>
                    <p class="kb-card__desc">{domain.description}</p>
                  </div>

                  <div class="kb-card__footer">
                    <div class="kb-card__tags">
                      <For each={domain.tags}>{(tag) => <span class="kb-card__tag">{tag}</span>}</For>
                    </div>
                    <span class="kb-card__enter">进入 →</span>
                  </div>
                </a>
              )
            }}
          </For>
        </div>

        <footer class="kb-foot">更多领域资料持续接入中 · 如需补充内容请联系安全知识运营</footer>
      </div>
    </div>
  )
}

export default KnowledgeBaseView
